import { utils } from "ethers";

export const NETWORK_MAP = {
    MATIC: {
        CHAIN_ID_DECIMAL: 137,
        RPC_URL: "https://polygon-rpc.com",
        BLOCK_EXPLORER_URL: "https://www.polygonscan.com/",
        HOST: "matic",
        NETWORK_CONFIG: {
            chainId: utils.hexValue(137), // '0x89'
            chainName: "Polygon Mainnet",
            nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
            rpcUrls: ["https://rpc-mainnet.maticvigil.com"],
            blockExplorerUrls: ["https://www.polygonscan.com/"],
        },
    },
    MUMBAI: {
        CHAIN_ID_DECIMAL: 80001,
        RPC_URL: "https://rpc-mumbai.maticvigil.com",
        BLOCK_EXPLORER_URL: "https://mumbai.polygonscan.com/",
        HOST: "mumbai",
        NETWORK_CONFIG: {
            chainId: utils.hexValue(80001), // '0x13881'
            chainName: "Mumbai Test Network",
            nativeCurrency: { name: "tMATIC", symbol: "tMATIC", decimals: 18 },
            rpcUrls: ["https://rpc-mumbai.maticvigil.com"],
            blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
        },
    },
};

export const NETWORK_MAP_BY_CHAIN_ID = Object.entries(NETWORK_MAP).reduce(
    (acc, [networkName, network]) => {
        const { CHAIN_ID_DECIMAL } = network;
        acc[CHAIN_ID_DECIMAL] = network;
        return acc;
    },
    {} as { [chainId: number]: typeof NETWORK_MAP[keyof typeof NETWORK_MAP] },
);
